import { FileuploadService } from '../../../service/http/fileupload.service';
import { Image } from '../../../model/Image'
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatPaginator, MatSort} from '@angular/material';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import {Sort} from '@angular/material';
import {AcceptDeclineDialogComponent} from "../../../dialog/accept-decline-dialog/accept-decline-dialog.component";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-workflow-images',
  templateUrl: './workflow-images.component.html',
  styleUrls: ['./workflow-images.component.css']
})
export class WorkflowImagesComponent implements OnInit {

  displayedColumns: string[] = ['name', 'type', 'date', 'size', 'actions'];
  data: Image[] = [];
  resultsLength = 0;
  isLoadingResults = true;
  currentPackageId;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private uploadService: FileuploadService,
              private translate: TranslateService,
              public dialog: MatDialog) {

    uploadService.currentPackageId.subscribe( currentPackageId => {
      if(currentPackageId !== null) {
        this.currentPackageId = currentPackageId;
        this.loadTableData();
      }

    })

  }

  ngOnInit() {
    this.currentPackageId = sessionStorage.getItem('currentPackageId');
    if(this.currentPackageId!==null){
      this.loadTableData();
    }

  }

  dialogClosed($event) {
    this.loadTableData()
  }

  loadTableData() {

    // merge(this.sort.sortChange, this.paginator.page)
    merge(this.paginator.page)
      .pipe(
        startWith([]),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.uploadService.fetchImageList(this.paginator.pageIndex, this.currentPackageId);
        }),
        map(data => {
          this.isLoadingResults = false;
          // length has to be provided in the json file
          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);

    this.uploadService.getTotalImageCount(this.currentPackageId).subscribe( data => this.resultsLength = data);
  }

  sortData(sort: Sort) {
    const data = this.data.slice();
    if (!sort.active || sort.direction === '') {
      this.data = data;
      return;
    }

    this.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'type': return this.compare(a.type, b.type, isAsc);
        case 'size': return this.compare(a.size, b.size, isAsc);
        case 'date': return this.compare(a.lastModified, b.lastModified, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  deleteImage(id: number, imageName: string) {

    const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
      width: '250px',
      data: {
        title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
        message: this.translate.instant('Do you really want to delete the image ?'),
        icon: {
          add: false,
          name: ''
        }}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result == true) {
        this.uploadService.deleteImage(this.currentPackageId, imageName).subscribe(data => {
          this.loadTableData();
        });
      }
    });
  }
}
